import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DubaiPin } from "../../../../app-constants";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What services does your web development company offer?",
    answer: `<p>TekRevol is a top-tier web development company in Dubai that offers custom web and mobile development, e-commerce solutions, UI/UX design, CMS development, digital strategy, SEO, and ongoing support for a comprehensive online presence.</p>`,
  },
  {
    question: "How experienced is your web development team?",
    answer: `<p>TekRevol web development team is highly experienced, with years of collective expertise.We excel in crafting innovative solutions for diverse projects across industries, ensuring client success.</p>`,
  },
  {
    question: "What technologies and platforms do you specialize in?",
    answer: `<p>At TekRevol, we specialize in cutting-edge technologies and platforms for web development. Our expertise includes proficiency in HTML5, CSS3, JavaScript, React, Angular, Node.js, Python, Django, and WordPress.</p>`,
  },
  {
    question: "What is your web development process like?",
    answer: `<p>TekRevol&#39;s web development process involves strategic planning, innovative design, and technical execution. From discovery to launch, we ensure a collaborative, client-focused approach for customized and successful solutions.</p>`,
  },
  {
    question:
      "How long does it typically take to complete a web development project?",
    answer: `<p>The process of designing and deploying a professionally built website could take between five and six months.However, there are several factors such as project complexity, scope adjustments, client responsiveness, and unforeseen challenges that can impact the timeline of the project.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
